package team.platforma.dictionary_presentation

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.flow.transform
import kotlinx.coroutines.launch
import team.platforma.dictionary_domain.AiChapterUseCase
import team.platforma.dictionary_domain.AiModelUseCase
import team.platforma.dictionary_presentation.model.AiChapterPresentation
import team.platforma.dictionary_presentation.model.AiModelPresentation

class DictionaryViewModel(
    private val aiChapterUseCase: AiChapterUseCase,
    private val aiModelUseCase: AiModelUseCase
) : ViewModel() {

    val aiChapterList: StateFlow<List<AiChapterPresentation>> =
        aiChapterUseCase.table.observe().map { value ->
            value.map {
                AiChapterPresentation(
                    it.id,
                    it.name
                )
            }
        }.stateIn(
            scope = viewModelScope,
            started = SharingStarted.Eagerly,
            initialValue = emptyList()
        )

    fun loadAiChapter() {
        viewModelScope.launch {
            aiChapterUseCase.network.load()
        }
    }

    fun loadAiModels(){
        viewModelScope.launch {
            aiModelUseCase.network.load()
        }
    }

    fun observeAllAiModels(): Flow<List<AiModelPresentation>> =
        aiModelUseCase.table.observeAll().transform { value ->
        val list = value.map {
            AiModelPresentation(
                id = it.id,
                name = it.name,
                chapter = it.chapter,
                description = it.description,
                cover = it.cover
            )
        }
           return@transform emit(list)
    }

    fun observeAiModelsByChapter(chapter: Long): Flow<List<AiModelPresentation>> =
        aiModelUseCase.table.observeByChapter(chapter).transform { value ->
           val list = value.map {
                AiModelPresentation(
                    id = it.id,
                    name = it.name,
                    chapter = it.chapter,
                    description = it.description,
                    cover = it.cover
                )
            }
            return@transform emit(list)
        }

}